import Skeleton from '@material-ui/lab/Skeleton/Skeleton';
import classNames from 'clsx';
import React, { Fragment } from 'react';

import { GameView } from '@swf/poker';

import type { HGPokerGameTile } from '../../types/common';

import styles from './GameTileSkeleton.scss';

const Tile = ({ type }: { type: GameView }) => (
  <div className={styles.tile}>
    {type === GameView.Grid ? (
      <>
        <div className={styles.imgContainer}>
          <Skeleton variant="rect" />
        </div>
        <Skeleton variant="rect" className={styles.footer} />
      </>
    ) : (
      <Skeleton variant="rect" />
    )}
  </div>
);

const GameTileSkeleton = ({ type, games }: { type: GameView; games: HGPokerGameTile[] }) => (
  <div
    className={classNames(styles.skeleton, {
      [styles.list]: type === GameView.List,
      [styles.grid]: type === GameView.Grid
    })}
  >
    {games.length ? (
      games.map(({ id }, index) => (
        <Fragment key={id}>
          {type === GameView.List && index === 0 && <Skeleton variant="rect" />}
          <Tile key={`${id}-skeleton`} type={type} />
        </Fragment>
      ))
    ) : (
      <>
        <Tile type={type} />
        <Tile type={type} />
        <Tile type={type} />
      </>
    )}
  </div>
);

export default GameTileSkeleton;
